import React from 'react';
import { isEmpty } from 'ramda';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { TextField, Button } from '@material-ui/core';

import UserPresenter from 'presenters/UserPresenter';
import validationSchema, { getDefaultAttributes } from 'forms/loanOfficerAutoFollowupsMessagesForm';

import useStyles from './useStyles';

const AutoFollowupsMessagesForm = props => {
  const { currentUser, onSubmit } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const initialValues = getDefaultAttributes(currentUser);

  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit,
  });
  const { errors, values, handleChange, handleBlur, touched, handleSubmit } = formik;

  const isAbleToSubmit = isEmpty(errors);

  return (
    <div className={classes.container}>
      <TextField
        error={touched.firstMessage && Boolean(errors.firstMessage)}
        helperText={touched.firstMessage && t(errors.firstMessage)}
        label={t('components.LoanOfficerSettings.AutoFollowupsMessages.AutoFollowupsMessagesForm.firstMessage')}
        variant="outlined"
        id="firstMessage"
        name="firstMessage"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.firstMessage}
        className={classes.field}
        type="text"
        multiline
        rows="4"
        FormHelperTextProps={{
          style: {
            marginLeft: 0,
          },
        }}
        InputLabelProps={{
          shrink: false,
        }}
      />
      <TextField
        error={touched.secondMessage && Boolean(errors.secondMessage)}
        helperText={touched.secondMessage && t(errors.secondMessage)}
        label={t('components.LoanOfficerSettings.AutoFollowupsMessages.AutoFollowupsMessagesForm.secondMessage')}
        variant="outlined"
        id="secondMessage"
        name="secondMessage"
        className={classes.field}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.secondMessage}
        type="text"
        multiline
        rows="4"
        FormHelperTextProps={{
          style: {
            marginLeft: 0,
          },
        }}
        InputLabelProps={{
          shrink: false,
        }}
      />
      <TextField
        error={touched.thirdMessage && Boolean(errors.thirdMessage)}
        helperText={touched.thirdMessage && t(errors.thirdMessage)}
        label={t('components.LoanOfficerSettings.AutoFollowupsMessages.AutoFollowupsMessagesForm.thirdMessage')}
        variant="outlined"
        id="thirdMessage"
        name="thirdMessage"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.thirdMessage}
        className={classes.field}
        type="text"
        multiline
        rows="4"
        FormHelperTextProps={{
          style: {
            marginLeft: 0,
          },
        }}
        InputLabelProps={{
          shrink: false,
        }}
      />
      <Button className={classes.button} onClick={handleSubmit} disabled={!isAbleToSubmit}>
        {t('components.LoanOfficerSettings.AutoFollowupsMessages.AutoFollowupsMessagesForm.saveButton')}
      </Button>
    </div>
  );
};

AutoFollowupsMessagesForm.propTypes = {
  currentUser: UserPresenter.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AutoFollowupsMessagesForm;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/AutoFollowupsMessages/components/AutoFollowupsMessagesForm/AutoFollowupsMessagesForm.js